import React from 'react';

function NationalityList({ nationalities, onSelectNationality, selectedNationality }) {
  return (
    <div
      className="absolute bg-white border border-[#f5f3ef] w-full mt-1 max-h-60 overflow-y-auto z-10 rounded-md shadow-lg"
      style={{ top: 'calc(100% + 4px)' }}
    >
      <ul>
        {nationalities.length > 0 ? (
          nationalities.map((nationality) => (
            <li
              key={nationality.value}
              className={`p-2 hover:bg-gray-200 cursor-pointer ${
                nationality.value === selectedNationality ? 'bg-gray-200' : ''
              }`} // Highlight the selected nationality
              onClick={() => onSelectNationality(nationality)} // Handle click to select
            >
              {nationality.label} ({nationality.value})
            </li>
          ))
        ) : (
          <li className="p-2 text-gray-500">No results found</li>
        )}
      </ul>
    </div>
  );
}

export default NationalityList;
